import { Link } from "react-router-dom";

const TCSBrand = () => {
  return (
    <div className="text-2xl font-extrabold bg-slate-100 rounded py-1 px-2">
      <Link to="/parts/open" className="hover:underline decoration-primary">
        <span className="text-secondary drop-shadow-textShadow">Techcycle</span>
        <span className="text-primary">Solutions.</span>
      </Link>
    </div>
  );
};

export default TCSBrand;
